// Emits <title> + og:title via vike-react; one source so the tags never duplicate.
import type { PageContext } from "vike/types";

import { pageTitle } from "./_pageTitle";
import { type Data } from "./_types";

export default function title(pageContext: PageContext): string {
  return pageTitle(pageContext.data as Data | undefined);
}
